import { useQuery } from 'react-query';
import { http } from '../http';

const NIBC_BTL_ID = 440;

async function getCommercialProducts(): Promise<number[]> {
  const response = await http.get('/api/authorizations/commercial-products');
  return response.data.commercialProducts;
}

export function useCommercialProducts() {
  const result = useQuery(['commercial-products'], () => getCommercialProducts());

  // TODO: prefetch?
  const commercialProducts = result.data ?? [];
  const isBtlAllowed = commercialProducts.includes(NIBC_BTL_ID);

  return {
    isBtlAllowed,
    commercialProducts,
  };
}
